var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6348 4.85778L26.9042 1.15116L40.678 14.6753L27.0566 28.0993L13.7402 15.2263V17.6807L11.1989 17.5805V11.5698V11.0689H17.603L17.5522 13.2728V13.6234L15.4683 13.5733L21.3641 19.2335L25.6335 14.6252L14.9092 4.20662L4.23579 14.6252L14.9601 25.0939L17.5014 22.7397L19.1786 24.3426L15.4175 28.0993L15.0109 28.5L0.677979 14.525L14.9601 0.5L30.2078 15.627L27.1075 15.5268L27.0566 17.5304L33.4099 17.5805V11.5698H31.4277L31.3768 13.8739L22.6348 4.85778Z",
    fill: "#5260FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCwIcon);
export default __webpack_public_path__ + "static/media/LogoCwIcon.e9d62576a2527a4197919c0311616616.svg";
export { ForwardRef as ReactComponent };